export default "__VITE_ASSET__BE$IHCmD__"